var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeletedEndUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[M]]-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(-17.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(17.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-User-Deleted"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAEEEE",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1399318,19.5025 C23.1399318,20.5625 22.2838409,21.4225 21.2286591,21.4225 C20.1734773,21.4225 19.3173864,20.5625 19.3173864,19.5025 C19.3173864,18.4425 20.1734773,17.5825 21.2286591,17.5825 C22.2838409,17.5825 23.1399318,18.4425 23.1399318,19.5025 Z M24.4265568,19.6125 C24.4265568,17.225 22.5003523,15.29 20.1237045,15.29 C17.7470568,15.29 15.8208523,17.225 15.8208523,19.6125 C15.8208523,22 17.7470568,23.935 20.1237045,23.935 C22.5003523,23.9325 24.4265568,21.9975 24.4265568,19.6125 Z M27.5771705,19.6125 C27.5771705,23.065 25.2502955,25.97 22.08475,26.835 L20.7807045,28.4225 C20.4397614,28.8375 19.8076477,28.8375 19.4667045,28.4225 L18.1651477,26.835 C14.9996023,25.97 12.6727273,23.065 12.6727273,19.6125 C12.6727273,15.4775 16.0099886,12.125 20.1237045,12.125 C24.2399091,12.125 27.5771705,15.4775 27.5771705,19.6125 Z",
    id: "Shape",
    fill: "#EFC0C0",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedEndUserAvatar);
export default __webpack_public_path__ + "static/media/deletedEndUserAvatar.6f8c9d3bf64abc141bdbc8912e5695e2.svg";
export { ForwardRef as ReactComponent };